import { HOUR_MS } from '@calm/web-common/dist/time';
import { createRandomQuotesApi } from '@rhg/libs/api/create-random-quotes-api';
import { queryKeys, useQuery } from '@rhg/libs/react-query';
import { useMemo } from 'react';

export const randomQuoteOptions = {
    queryKey: [queryKeys.quotes],
    queryFn: async () => {
        const randomQuotesApi = createRandomQuotesApi();
        const response = await randomQuotesApi.getCalmRandomQuotes();
        return response.data;
    },
    queryOptions: { staleTime: 8 * HOUR_MS },
};

export function useRandomQuotes() {
    const { data, ...otherProps } = useQuery({
        queryKey: randomQuoteOptions.queryKey,
        queryFn: async () => randomQuoteOptions.queryFn(),
        ...randomQuoteOptions.queryOptions,
    });
    return {
        data,
        ...otherProps,
    };
}

export function useSelectRandomQuote() {
    const { data: loadingQuotes } = useRandomQuotes();

    const selectedQuote = useMemo(() => {
        if (!loadingQuotes || loadingQuotes.length === 0) {
            return null;
        }

        const randomIndex = Math.floor(Math.random() * loadingQuotes.length);
        return loadingQuotes[randomIndex];
    }, [loadingQuotes]);

    return selectedQuote;
}
